import { CURRENT_COUNTRY } from "utils/constants";

const formatDate = (date, language = "en", options = {
	day: "numeric", weekday: undefined, month: "long", year: true
}) =>
	new Date(date).toLocaleString(language !== "en" ? `${CURRENT_COUNTRY}-${CURRENT_COUNTRY.toUpperCase()}` : "en-GB", {
		day: options.day,
		month: options.month,
		year: options.year ? "numeric" : undefined,
		weekday: options.weekday,
	});

export const shopifyFormatDate = (date) => new Date(date).toISOString().slice(0, 19) + "Z";

export const shortDate = (date, lang) => formatDate(date, lang, { day: "2-digit", month: "2-digit" }).replace(/\//g, ".").slice(0, 5);

export const getDayName = (currentDate, language) => {
	const date = new Date(currentDate);
	const days = {
		en: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
		default: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
		nl: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"]
	};

	return days[language] ? days[language][date.getDay()] : "";
};

export default formatDate;

export const convertToISOString = (date) => {
	if (!date) return;
	const [day, month, year] = date?.split(".");
	const customDate = new Date(year, month - 1, day, 15, 30, 0, 123);
	return customDate?.toISOString().slice(0, -1);
};



/**
 * Converts a Date object to a simple date string in the format "YYYY-MM-DD".
 *
 * The output string uses four-digit year, two-digit month, and two-digit day,
 * separated by hyphens. This format is commonly used in HTML date inputs
 * and libraries like Flatpickr.
 *
 * @param {Date} date - The Date object to format.
 * @returns {string} The formatted date string in "YYYY-MM-DD" format.
 */
export const formatToSimpleDate = (date) => {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
	const d = String(date.getDate()).padStart(2, "0");
	return `${y}-${m}-${d}`;
};
